// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_m4-0";